import React from 'react';
import Lottie from 'react-lottie';

function LottieLoader() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: null, // This will be dynamically loaded
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
  
    const [animationData, setAnimationData] = React.useState(null);
  
    React.useEffect(() => {
      fetch('https://lottie.host/ecef366a-b5e2-4341-97fa-447cf36d5f87/2skvz2IuzR.json')
        .then(response => response.json())
        .then(data => {
          setAnimationData(data);
        })
        .catch(error => {
          console.error('Error loading Lottie file:', error);
          alert('Failed to load animation');
        });
    }, []);
  
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // Make sure it takes full viewport height
        width: '100vw', // Make sure it takes full viewport width
        position: 'absolute',
        top: 0,
        left: 0,
      }}>
        {animationData ? (
          <Lottie 
            options={{ ...defaultOptions, animationData: animationData }}
            height={200}
            width={200}
            isStopped={false}
            isPaused={false}
          />
        ) : (
          <p>Loading Experience...</p>
        )}
      </div>
    );
  }  

export default LottieLoader;
